import { honeyTokenContract } from "config";
import { BigNumber } from "ethers";
import { useMemo } from "react";
import { useContractRead } from "wagmi";

const useHoneyAllowance = (
  spender: string,
  address?: string
): [BigNumber | undefined, () => void] => {
  const args = useMemo(
    () => address && spender && [address, spender],
    [address, spender]
  );

  const [{ data: allowance }, readAllowance] = useContractRead(
    {
      addressOrName: honeyTokenContract.address,
      contractInterface: honeyTokenContract.interface,
    },
    "allowance",
    {
      args,
    }
  );

  return [allowance as unknown as BigNumber, readAllowance];
};

export default useHoneyAllowance;
